import { useState } from 'react';
import { Radio } from '@mweb/zappos-ui/Radio';

import { Drawer } from 'components/common/Drawer';
import { useFilteredSortOptions } from 'hooks/useFilteredSortOptions';
import { filterSortOptions } from 'utils/filterSortOptions';
import { useSortSelectedValue } from 'hooks/useSortSelectedValue';
import type { SortOptionProps } from 'components/search/Sort';

interface SortDrawerProps {
  isBestForYouSortEligible: boolean;
  selectedSort: SortOptionProps;
  onSortSelected: React.ChangeEventHandler<HTMLInputElement>;
}

export const SortDrawer = ({ isBestForYouSortEligible, onSortSelected, selectedSort }: SortDrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = useFilteredSortOptions();
  const options = filterSortOptions(sortOptions, !!isBestForYouSortEligible);
  const selectedValue = useSortSelectedValue(options, selectedSort);

  const handleSortSelected: React.ChangeEventHandler<HTMLInputElement> = event => {
    setIsOpen(false);
    onSortSelected(event);
  };

  return (
    <Drawer.Root open={isOpen} onOpenChange={setIsOpen}>
      <Drawer.Trigger
        onClick={() => setIsOpen(true)}
        className="z- body-xs-subtle flex h-10 items-center justify-center gap-2 rounded-sm border border-gray-200 px-4 max-sm:w-full sm:w-auto"
      >
        Sort
      </Drawer.Trigger>

      <Drawer.Content shouldAnimate>
        <Drawer.Header>Sort</Drawer.Header>

        <div className="flex w-full flex-col px-5 py-4">
          {options.map(({ eventLabel, label, value, ariaLabel }) => {
            const isChecked = selectedValue?.value === value;
            return (
              <Radio
                key={value}
                checked={isChecked}
                label={label}
                data-label={eventLabel || label}
                aria-label={ariaLabel || label}
                value={value}
                onChange={handleSortSelected}
                className="body-s h-11"
              />
            );
          })}
        </div>
      </Drawer.Content>
    </Drawer.Root>
  );
};
